import type { JSX } from 'react';
import { Pencil, Trash2, Mail, Link, Copy, ExternalLink } from 'lucide-react';
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { useCertificateLink } from '../hooks/useCertificateLink';
import type { CandidateActionsMenuProps } from './CandidateActions.utils';
import { CandidateStatusSubmenu } from './CandidateStatusSubmenu';

export function CandidateActionsMenu({
  candidateId,
  shareId,
  status,
  onEdit,
  onResendInvitation,
  onCopyLink,
  onDelete,
  onStatusClick,
}: CandidateActionsMenuProps): JSX.Element {
  const { copyCertificateLink, openCertificate } = useCertificateLink();

  return (
    <>
      <DropdownMenuItem onClick={onEdit}>
        <Pencil className="mr-2 h-4 w-4" />
        Edit
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => onResendInvitation(candidateId)}>
        <Mail className="mr-2 h-4 w-4" />
        Resend Invitation
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => onCopyLink(shareId)}>
        <Link className="mr-2 h-4 w-4" />
        Copy Link
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => copyCertificateLink(shareId)}>
        <Copy className="mr-2 h-4 w-4" />
        Copy Certificate Link
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => openCertificate(shareId)}>
        <ExternalLink className="mr-2 h-4 w-4" />
        Open Certificate
      </DropdownMenuItem>
      <CandidateStatusSubmenu status={status} onStatusClick={onStatusClick} />
      <DropdownMenuSeparator />
      <DropdownMenuItem variant="destructive" onClick={onDelete}>
        <Trash2 className="mr-2 h-4 w-4" />
        Delete
      </DropdownMenuItem>
    </>
  );
}
